// @mui
import { Stack, Typography } from '@mui/material';
import { ArticleProps } from 'src/@types/article';
//
import BlogPostItemMobile from './BlogPostItemMobile';

// ----------------------------------------------------------------------

type BlogSidebarRecentPosts = {
  recentPosts: {
    list: ArticleProps[];
    path: string;
  };
};

export default function BlogSidebarRecentPosts({ recentPosts }: BlogSidebarRecentPosts) {
  const { list, path } = recentPosts;

  return (
    <Stack spacing={3}>
      <Typography variant="h4" gutterBottom>
        Flere artikler
      </Typography>
      {list.map((article) => (
        <BlogPostItemMobile key={article.slug.current} article={article} onSiderbar path={path} />
      ))}
    </Stack>
  );
}
